var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiNutFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.041 3.706L4.706 20.959",
    stroke: "#31544e",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.428c.142 0 .281-.015.416-.043v.645c0 1.71-.903 3.29-2.358 4.12l-1.202.687a1.224 1.224 0 01-1.214 0l-1.202-.687c-1.454-.83-2.357-2.41-2.357-4.12v-.645c.134.028.274.043.416.043zm-.834-4.285H12.31a1.23 1.23 0 01.072-.688c.166-.397.486-.575.616-.633a.434.434 0 00.217-.563.411.411 0 00-.547-.223 2.065 2.065 0 00-1.198 2.107H9.083C7.935 8.143 7 9.104 7 10.285c0 .71.56 1.286 1.25 1.286h7.5c.69 0 1.25-.577 1.25-1.286 0-1.181-.935-2.142-2.083-2.142z",
    fill: "#31544e"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--nut-free-dafe954cff437b432c51a3fead9155f7.svg";
export { SvgIconUiNutFree as Component };